import * as React from 'react'
import { ReactElement } from 'react'
import {
    CheckboxVisibility,
    DetailsListLayoutMode,
    IDetailsListProps,
    IDetailsRowProps,
    IObjectWithKey,
    SelectionMode,
    ShimmeredDetailsList,
    Text,
} from '@fluentui/react'
import { IRenderFunction } from '@fluentui/utilities'
import { IShimmeredDetailsListProps } from '@fluentui/react/lib/components/DetailsList/ShimmeredDetailsList.types'
import { useTranslation } from 'react-i18next'

const noItem: IObjectWithKey = { key: 'no-item' }

type Props = Omit<IShimmeredDetailsListProps, 'styles'> & Pick<IDetailsListProps, 'styles'>

// noinspection JSUnusedGlobalSymbols
export default function BaseDetailsList(props: Props): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <ShimmeredDetailsList
            compact
            layoutMode={DetailsListLayoutMode.justified}
            onShouldVirtualize={() => true}
            usePageCache
            useReducedRowRenderer={false}
            selectionMode={SelectionMode.none}
            checkboxVisibility={CheckboxVisibility.hidden}
            {...props}
            items={(props.items || []).length > 0 ? props.items : [noItem]}
            onRenderRow={(rowProps: IDetailsRowProps, render: IRenderFunction<IDetailsRowProps>) => {
                // An empty item is provided by applyFilters() when no items are set.
                if (rowProps.item.key === noItem.key) {
                    return (
                        <Text variant="medium" block styles={{ root: { padding: '6px', textAlign: 'center' } }}>
                            <em>{translate('base.table.empty')}</em>
                        </Text>
                    )
                }
                return props.onRenderRow?.(rowProps, render) || render(rowProps)
            }}
        />
    )
}
